module.exports = __webpack_public_path__ + "img/admin-logo.0339ab42.svg";